import { FC } from "react";
import clsx from "clsx";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
}

const Offcanvas: FC<IProps> = ({ isOpen, onClose, children, className }) => {
  return (
    <button
      className={clsx(
        "fixed inset-0 z-50 overflow-y-hidden bg-black/70 cursor-crosshair transition-[visibility] duration-200",
        !isOpen && "invisible",
        isOpen && "visible"
      )}
      onClick={onClose}
      tabIndex={-1}
    >
      <button
        className={clsx(
          "offcanvas w-full h-full ml-auto overflow-x-hidden overflow-y-auto bg-white cursor-auto transition-transform duration-300",
          !isOpen && "translate-x-[120%]",
          isOpen && "translate-x-0",
          className
        )}
        onClick={(e) => e.stopPropagation()}
        tabIndex={-1}
      >
        {children}
      </button>
    </button>
  );
};

export default Offcanvas;
